<div class="chart-overview-container" *ngIf="chartData">
  <div class="chart-header">
    <div class="chart-title-wrapper">
      <h3
        class="chart-title"
        [matTooltip]="chartData.title || 'Chart'"
        matTooltipPosition="below">
        {{ chartData.title || 'Chart' }}
      </h3>
      <span class="duration-badge" *ngIf="getDurationBehaviorLabel()" [ngClass]="getDurationBehaviorClass()">
        {{ getDurationBehaviorLabel() }}
      </span>
    </div>
    <div class="chart-actions">
      <button
        class="btn-action btn-large-view"
        (click)="onExpand(); $event.stopPropagation()"
        (mouseenter)="isLargeViewHovered = true"
        (mouseleave)="isLargeViewHovered = false"
        [matTooltip]="'View in Large'"
        matTooltipPosition="below">
        <img [src]="isLargeViewHovered ? 'assets/icons/user-dashbaord/large-view-hover.svg' : 'assets/icons/user-dashbaord/large-view.svg'" alt="expand" />
      </button>
      <div class="menu-container" (click)="$event.stopPropagation()">
        <button
          class="btn-action btn-more"
          (click)="onMore($event)"
          (mouseenter)="isMoreHovered = true"
          (mouseleave)="isMoreHovered = false">
          <img [src]="isMoreHovered ? 'assets/icons/user-dashbaord/more-svg-hover.svg' : 'assets/icons/user-dashbaord/more-svg-grey.svg'" alt="more" />
        </button>
        <div class="chart-menu" *ngIf="showMenu" (click)="$event.stopPropagation()">
          <button
            class="menu-item"
            *ngIf="isEditMode"
            (click)="onEdit()"
            >
            <img src="assets/icons/user-dashbaord/edit-chart.svg" alt="edit" class="menu-icon" />
            <span>Edit Chart</span>
          </button>
          <button
            class="menu-item"
            (click)="onDownload()"
            >
            <img src="assets/icons/user-dashbaord/download-csv.svg" alt="download" class="menu-icon" />
            <span>Export Data</span>
          </button>
          <button
            class="menu-item"
            (click)="onDownloadImage()"
            >
            <img src="assets/icons/user-dashbaord/download-csv.svg" alt="download" class="menu-icon" />
            <span>Export Chart</span>
          </button>
          <button
            class="menu-item delete-item"
            *ngIf="isEditMode"
            (click)="onDelete()"
            >
            <img src="assets/icons/user-dashbaord/delete-chart.svg" alt="delete" class="menu-icon" />
            <span>Delete Chart</span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="chart-content">
    <div *ngIf="isLoading" class="chart-loading">
      <div class="loading-spinner"></div>
      <p>Loading chart data...</p>
    </div>
    <div *ngIf="hasError && !isLoading" class="chart-error">
      <div class="error-content">
        <div class="error-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#F44336"/>
          </svg>
        </div>
        <div class="error-message-container">
          <p class="error-message">{{ errorMessage || 'Failed to load chart data' }}</p>
          <p class="error-suggestion" *ngIf="chartData.no_data_found">
            Try adjusting your date range or filters to see results
          </p>
        </div>
      </div>
    </div>
    <div *ngIf="!hasError && !isLoading && chartOptions" class="chart-container">
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="chartOptions"
        (chartInstance)="chartRef = $event"
        style="width: 100%; height: 100%; display: block;"
      ></highcharts-chart>
    </div>
    <div *ngIf="!hasError && !isLoading && !chartOptions" class="chart-empty">
      <div class="no-data-container">
        <div class="no-data-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 11H7V13H9V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M13 11H11V13H13V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M17 11H15V13H17V11Z" fill="currentColor" opacity="0.3"/>
            <path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z" fill="currentColor"/>
          </svg>
        </div>
        <p class="no-data-message">No data found</p>
        <p class="no-data-subtitle">There is no data available to display for this chart</p>
      </div>
    </div>
  </div>
  <div class="chart-footer">
    <div class="footer-content">
      <div class="footer-row">
        <div class="timestamp-info">
          <span class="timestamp-label">Last updated:</span>
          <span class="timestamp-value">{{ getLastUpdatedTime() }}</span>
        </div>
      </div>
      <div class="footer-row" *ngIf="getLastEditedTime() || getLastEditedBy()">
        <div class="timestamp-info">
          <span class="timestamp-label">Last edited:</span>
          <span class="timestamp-value">
            <ng-container *ngIf="getLastEditedTime()">{{ getLastEditedTime() }}</ng-container>
            <ng-container *ngIf="getLastEditedBy()">
              <span *ngIf="getLastEditedTime()"> by </span>{{ getLastEditedBy() }}
            </ng-container>
          </span>
        </div>
      </div>
      <!-- <div class="footer-row" *ngIf="hasAppliedFilters()">
        <div class="filters-info">
          <span class="filters-label">Filters:</span>
          <span class="filters-value">{{ getAppliedFilters() }}</span>
        </div>
      </div> -->
    </div>
  </div>
</div>
